import { createAction, props } from "@ngrx/store";
import { TrainData } from "../../models/trainDataModel";
import { MessageData } from "../../models/messageDataModel";

export const fetchTrainData = createAction(
    '[Home] Fetch Train Data'
)

export const updateTrainData = createAction(
    '[Home] Update Train Data',
    props<{ trainData: TrainData}>()
)

export const fetchMessageData = createAction(
    '[Home] Fetch Message Data'
)

export const pollAllTrainDataSync = createAction(
    '[Home] Start polling Message and Train Data'
)

export const stopPollingTrainDataSync = createAction(
    '[Home] Stop polling Message and Train Data'
)

export const updateMessageData = createAction(
    '[Home] Update Message Data',
    props<{ messageData: MessageData[]}>()
)

export const trainDataError = createAction(
    '[Home] Train Data Error',
    props<{ error: any }>()
)

export const messageDataError = createAction(
    '[Home] Message Data Error',
    props<{ error: any }>()
)